import { z } from 'zod'

export const searchQuerySchema = z.object({
  q: z.string().min(2, 'Search query must be at least 2 characters').max(100),
  type: z.enum(['all', 'reflections']).default('all'),
  bookId: z.string().optional(),
  roomId: z.string().optional(),
  dateFrom: z.coerce.date().optional(),
  dateTo: z.coerce.date().optional(),
  page: z.coerce.number().min(1).default(1),
  limit: z.coerce.number().min(1).max(50).default(20),
})

export type SearchQuery = z.infer<typeof searchQuerySchema>

export const archiveSearchSchema = z.object({
  q: z.string().min(2).max(100),
  bookId: z.string().optional(),
  page: z.coerce.number().min(1).default(1),
  limit: z.coerce.number().min(1).max(50).default(20),
})

export type ArchiveSearchQuery = z.infer<typeof archiveSearchSchema>
